import { getConfig } from '@configs/envConfig'
import { ApiFilterResponse } from '@interfaces/ackoDrive'
import { errorWithStack } from '@utils/logger'

export const filterService = {
  getFilters: async (collectionSlug?: string, ackoDriveBaseUrl?: string): Promise<ApiFilterResponse | null> => {
    try {
      const baseURL = ackoDriveBaseUrl || getConfig(process.env.ACKO_ENV)?.ackoDriveBaseUrl
      const queryParams = new URLSearchParams()

      if (collectionSlug) {
        queryParams.append('slug', collectionSlug)
      }

      const apiUrl = `${baseURL}/api/filters?${queryParams.toString()}`

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        throw new Error(`Filter API HTTP error! Status: ${response.status}`)
      }

      const data = await response.json()

      return data
    } catch (error) {
      errorWithStack('Error fetching filter options from API:', error)
      return null
    }
  },
}
